import React, { useState } from 'react';
import cls from 'classnames';
import ToLeftIcon from 'material-icons-svg/components/baseline/KeyboardArrowLeft';
import ToRightIcon from 'material-icons-svg/components/baseline/KeyboardArrowRight';
import NewProjectIcon from 'material-icons-svg/components/baseline/FileCopy';
import ExportIcon from 'material-icons-svg/components/baseline/SaveAlt';
import { useOpenModal, useModel, useToolBoxState, useRenderer, useResetLayout } from '../../../hooks';
import ToolBoxIcon from './ToolBoxIcon';
import Layout from './Layout';
import NodeVariables from './NodeVariables';
import LabelVariables from './LabelVariables';
import EdgeVariables from './EdgeVariables';
import './ToolBox.scss';
function ControlButton(_a) {
    var Icon = _a.Icon, _b = _a.onClick, onClick = _b === void 0 ? null : _b;
    return (React.createElement("div", { className: "control-button", onClick: onClick },
        React.createElement(Icon, { height: 32, width: 32 })));
}
export default function ToolBox() {
    var _a = useState(true), expanded = _a[0], setExpanded = _a[1];
    var openModal = useOpenModal();
    var model = useModel();
    var renderer = useRenderer()[0];
    var _b = useToolBoxState(), toolBoxState = _b[0], toolBoxActions = _b[1];
    var resetLayout = useResetLayout();
    return (React.createElement("div", { id: "ToolBox", className: cls(expanded && 'expanded') },
        React.createElement("div", { id: "ToolBoxTop" },
            React.createElement("header", { className: "toolbox-header" },
                React.createElement("div", { className: "main-column" },
                    React.createElement("h1", { className: "app-logo" }, "nansi")),
                React.createElement("div", { className: "button-container" },
                    React.createElement(ToolBoxIcon, { Icon: NewProjectIcon, hint: "import a new graph", hintPosition: "bottom", onClick: function () { return openModal('import'); } })),
                React.createElement("div", { className: "button-container" },
                    React.createElement(ToolBoxIcon, { Icon: ExportIcon, hint: "export and download the graph", hintPosition: "bottom", onClick: function () { return openModal('export'); } })))),
        React.createElement("div", { id: "ToolBoxInner" }, model && (React.createElement(React.Fragment, null,
            React.createElement(Layout, { renderer: renderer, reset: resetLayout }),
            React.createElement(NodeVariables, { model: model.nodes, variables: toolBoxState.variables.nodes, defaultNodeColor: model.defaultNodeColor, defaultNodeSize: model.defaultNodeSize, actions: toolBoxActions }),
            React.createElement(LabelVariables, { model: model.nodes, variables: toolBoxState.variables.labels, defaultNodeLabel: model.defaultNodeLabel, actions: toolBoxActions }),
            React.createElement(EdgeVariables, { model: model.edges, variables: toolBoxState.variables.edges, defaultEdgeColor: model.defaultEdgeColor, defaultEdgeSize: model.defaultEdgeSize, actions: toolBoxActions })))),
        React.createElement(ControlButton, { Icon: expanded ? ToLeftIcon : ToRightIcon, onClick: function () { return setExpanded(!expanded); } })));
}
